module.exports = __webpack_public_path__ + "img/jcb.7ca034e.svg";